define('v3/Common/Components/Search/Search.Component',[
	'text!v3/Common/Components/Search/Search.Component.html',
	'env',
	'lodash',
	'v3/Common/Services/intentsService',
	'v3/Common/Bindings/SvgIcon.Binding'
], function (template, env, _, intents) {
	function search () {
		var self = this;

		self.openSearch = function () {
			window.location.href = '/V4/' + env.userInfo.classId + '/search';
		};

		self.visible = Settings ? Settings.showSearchButton : false;

		intents.registerIntentHandler('searchbox', {}, function () { self.openSearch(); });
	}

	return { viewModel: search, template: template };
});

